export default __webpack_public_path__ + "static/media/social-linkedin.e48b6c31.svg";